import React, { useContext } from "react";
import { ChangeEvent, useState } from "react";
import { Alert, Box, Button, Modal, Paper, Snackbar, Typography, useTheme } from "@mui/material";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from "@mui/icons-material/Close";
import { post, post_file } from "../../Services/tokenConfig";
import { BarraDeFerramentas } from "../barra-de-ferramentas/BarraDeFerramentas";
import { func_print } from "../../Func_genericas/func_print";
import LoadingVulpesSmall from "../../Styles/Loader/loadingSmall";
import { IBeneficiarios } from "../../Interfaces/beneficiarios/beneficiario";
import { AuthContext } from "../../AuthContext/AuthContext";
import { cores, imagens } from "../../Func_genericas/valores_estaticos";

export interface IUploadFileprops {
  onCloseDialog: React.Dispatch<React.SetStateAction<boolean>>;
  set_beneficiario: React.Dispatch<React.SetStateAction<IBeneficiarios[]>>;
  beneficiario: IBeneficiarios[];
  set_beneficiario_pesquisa: React.Dispatch<React.SetStateAction<IBeneficiarios[]>>;
  beneficiario_pesquisa: IBeneficiarios[];
}

const UploadFileIE: React.FC<IUploadFileprops> =
  ({ onCloseDialog, set_beneficiario, beneficiario, set_beneficiario_pesquisa, beneficiario_pesquisa }) => {
    const [file, setFile] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const auth = useContext(AuthContext);
    const [open_modal_img_example, set_open_modal_img_example] = React.useState<boolean>(false);

    /****** ALERTA **********************************/
    const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
    const [openSnackError, setOpenSnackError] = React.useState(false);
    const [message, setMessage] = useState("");

    const handleCloseSnack = () => {
      setOpenSnackSuccess(false);
      setOpenSnackError(false);
    };

    const onChange = (file: ChangeEvent) => {
      const { files } = file.target as HTMLInputElement;
      if (files && files.length !== 0) {
        setFile(files[0]);
      } else {
        setOpenSnackError(true);
      }
    };

    const handleUpload = async () => {
      try {
        setIsLoading(true);

        const formData = new FormData();
        formData.append("file", file);

        if (file !== undefined) {
          const response = await post_file(auth.token.cookie_token, "/uploadfile", formData);

          if (response.status === 200) {
            if (beneficiario.length === 0) {
              set_beneficiario([response.data.result])
              set_beneficiario_pesquisa([response.data.result])
            } else {

              let aux_obj = beneficiario.find((el) => {
                if (el.id_agri === response.data.result.id_agri) {
                  return el
                }

              })

              if (aux_obj !== undefined) {
                let aux_list_benef = beneficiario.filter((el) => {
                  if (el.id_agri !== response.data.result.id_agri) {
                    return el
                  }

                })
                let aux_list_benef_pesquisa = beneficiario_pesquisa.filter((el) => {
                  if (el.id_agri !== response.data.result.id_agri) {
                    return el
                  }

                })

                aux_list_benef.push(response.data.result)
                aux_list_benef_pesquisa.push(response.data.result)
                set_beneficiario(aux_list_benef)
                set_beneficiario_pesquisa(aux_list_benef_pesquisa)

              } else {



                set_beneficiario((oldList) => {
                  return [...oldList, response.data.result];
                });
                set_beneficiario_pesquisa((oldList) => {
                  return [...oldList, response.data.result];
                });
              }
            }

            setMessage("Ficheiro carregado com sucesso!")
            setOpenSnackSuccess(true);
            onCloseDialog(false);
          } else if (response.status === 208) {
            setMessage("O beneficiário já existe.")

            setOpenSnackError(true);
          } else if (response.status === 429) {
            setMessage("A sua conta não permite adicionar mais beneficiários.")

            setOpenSnackError(true);
          } else {
            setOpenSnackError(true);

          }

        } else {
          setMessage("Erro ao carregar o ficheiro.")
          setOpenSnackError(true);

        }
        setIsLoading(false);



      } catch (error) {
        func_print("handleUpload", error, true);
        if ((error as any)?.response?.data?.message) {
          setMessage((error as any).response.data.message);
        } else {
          setMessage("Erro ao carregar o ficheiro.");
        }
        setOpenSnackError(true);
        setIsLoading(false);
      }
    };

    return (
      <div>
        <Modal style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}

          open={open_modal_img_example}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            backgroundColor: 'white',
            width: '40%',
            height: '80%',
            flexDirection: 'column',
            borderRadius: 5,
            overflowY: 'scroll',

          }}>
            <div style={{
              width: '100%',
              display: "flex",
              alignItems: 'flex-start',
              justifyContent: 'flex-end',
              flex: 0.1,
            }}>

              <Button
                sx={{ color: "#AAAAAA" }}
                size="large"
                onClick={() => {
                  set_open_modal_img_example(false)
                }}
              >
                <CloseIcon />
              </Button>
            </div>
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: 'center',
              marginBottom: 10
            }}>
              <img
                width="100%"
                height="100%"
                src={imagens.IE_exemplo}
                alt="" />

            </div>

          </div>
        </Modal>
        <Box
          sx={{ "& button": { m: 1 } }}
          padding={2}
          width="100%"
          display="flex"
          alignItems="center"
          component={Paper}
          justifyContent="center"
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ? (
            <LoadingVulpesSmall />
          ) : (
            <Box padding={3}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: 'flex-start',
                marginBottom: 20
              }}>
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    alignItems: "flex-start",
                    bgcolor: "#F9F5F2",
                    borderRadius: 1,
                    p: 2,
                    maxWidth: 500
                  }}
                >
                  <InfoOutlinedIcon color="action" sx={{ mt: "2px" }} />

                  <Box>
                    <Typography variant="body2" color="text.secondary">
                    Visualizar o documento de exemplo para garantir que o ficheiro
                      segue o formato correto antes de fazer o upload.
                    </Typography>

                    <Button
                      variant="text"
                      size="small"
                      sx={{ mt: 1, pl: 0, color:cores.cor1 }}
                      onClick={()=>set_open_modal_img_example(true)}
                    >
                      Ver documento de exemplo
                    </Button>
                  </Box>
                </Box>
               
              </div>
              <form onSubmit={(e) => e.preventDefault()}>
                <Button
                  variant="contained"
                  component="label"
                  size="small"
                  sx={{
                    marginBottom: 5,
                    fontFamily: "candara",
                    backgroundColor: "#ccafa3",
                    "&:hover": {
                      backgroundColor: "#f2d1c2",
                      color: "#000000",
                    },
                  }}
                >
                  <input
                    style={{ color: "#7e2706", fontFamily: "candara" }}
                    accept=".pdf"
                    type="file"
                    onChange={onChange}
                  />
                </Button>

              </form>
              <Box sx={{ alignItems: 'center', justifyContent: 'end', display: 'flex' }}>
                <BarraDeFerramentas
                  mostrarBotaoGravar
                  aoClicarGravar={handleUpload}
                />
              </Box>

            </Box>
          )}
        </Box>
      </div>
    );
  };
export default UploadFileIE;
